import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { Uris } from '../public/Uris';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { GlobalFunction } from '../public/globalFunction';
import { field } from 'src/app/routes/agricola/fields/interfaces/fields.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FieldsAgricolaService {
  constructor(
    public http: HttpClient,
    public router: Router,
    public GlobalFunction: GlobalFunction
  ) {}

  cycleRegister(value: any) {
    return this.http
      .post(`${Uris.API_CYCLES}`, value, this.GlobalFunction.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  editCycle(id, value) {
    return this.http
      .put(`${Uris.API_CYCLES}${id}/`, value, this.GlobalFunction.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  getListPathingsID(id) {
    return this.http
      .get(`${Uris.API_PATHINGS}${id}/`, this.GlobalFunction.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  getListPathings(query) {
    return this.http
      .get(`${Uris.API_PATHINGS}${query}`, this.GlobalFunction.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  getCrops() {
    return this.http.get(`${Uris.CROPS}`, this.GlobalFunction.headers()).pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError((err: any) => {
        return this.GlobalFunction.validateError(err);
      })
    );
  }

  registerCrops(admin) {
    return this.http
      .post(`${Uris.CROPS}`, admin, this.GlobalFunction.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  getSeasons(query) {
    return this.http
      .get(`${Uris.API_SEASONS}${query}`, this.GlobalFunction.headers())
      .pipe(
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        }),
        map((resp: any) => {
          return resp;
        })
      );
  }

  createSeason(obj: any) {
    return this.http
      .post(`${Uris.API_SEASONS}`, obj, this.GlobalFunction.headers())
      .pipe(
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        }),
        map((resp: any) => {
          return resp;
        })
      );
  }

  editSeason(obj: any, id: any) {
    return this.http
      .patch(`${Uris.API_SEASONS}${id}/`, obj, this.GlobalFunction.headers())
      .pipe(
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        }),
        map((resp: any) => {
          return resp;
        })
      );
  }

  deleteSeason(id: any) {
    return this.http
      .delete(`${Uris.API_SEASONS}${id}/`, this.GlobalFunction.headers())
      .pipe(
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        }),
        map((resp: any) => {
          return resp;
        })
      );
  }

  createAgromonitoringPolygon(id) {
    return this.http
      .post(
        `${Uris.API_FIELDS}${id}/create_agromonitoring_polygon/`,
        {},
        this.GlobalFunction.headers()
      )
      .pipe(
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        }),
        map((resp: any) => {
          return resp;
        })
      );
  }

  getAgromonitoringPolygon(id) {
    return this.http
      .get(
        `${Uris.API_FIELDS}${id}/get_agromonitoring_polygon/`,
        this.GlobalFunction.headers()
      )
      .pipe(
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        }),
        map((resp: any) => {
          return resp;
        })
      );
  }

  deleteAgromonitoringPolygon(id) {
    return this.http
      .get(
        `${Uris.API_FIELDS}${id}/delete_agromonitoring_polygon/`,
        this.GlobalFunction.headers()
      )
      .pipe(
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        }),
        map((resp: any) => {
          return resp;
        })
      );
  }

  getAgromonitoringData(fieldID, obj) {
    return this.http
      .post(
        `${Uris.API_FIELDS}${fieldID}/get_sat_data/`,
        obj,
        this.GlobalFunction.headers()
      )
      .pipe(
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        }),
        map((resp: any) => {
          return resp;
        })
      );
  }

  getSatellitalData(query) {
    return this.http
      .get(`${Uris.API_SAT}${query}`, this.GlobalFunction.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }

  deleteSatellitalData(id) {
    return this.http
      .delete(`${Uris.API_SAT}${id}/`, this.GlobalFunction.headers())
      .pipe(
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        }),
        map((resp: any) => {
          return resp;
        })
      );
  }

  getNDVITileImage(id, obj) {
    return this.http
      .post(
        `${Uris.API_FIELDS}${id}/get_ndvi_tile/`,
        obj,
        this.GlobalFunction.headers()
      )
      .pipe(
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        }),
        map((resp: any) => {
          return resp;
        })
      );
  }
}
